import IApiClient from "./ApiClient";
import { AddProductResponse, ApplyCouponResponse, CheckCompanyForSaleResponse, GetProductConfigurationsResponse, GetProductsResponse, PendingOrderResponse, SaleStatusResponse, UpdateConfigurationRequest, UpdateConfigurationResponse, WebshopOrderModel, WebShopOrderResponse, WebshopProductModel } from "models/WebShop"

export interface IWebShopService {
  addProduct(formData: FormData): Promise<AddProductResponse | undefined>;
  hasPendingOrder(companyId: string, organizationNumber: string): Promise<PendingOrderResponse | undefined>;
  getProducts(): Promise<WebshopProductModel[] | undefined>;
  applyCoupon(code:string): Promise<ApplyCouponResponse | undefined>;
  addOrder(order: WebshopOrderModel): Promise<AddProductResponse | undefined>;
  getProductConfigurations(companyId: string): Promise<GetProductConfigurationsResponse | undefined>
  updateProductConfiguration(request: UpdateConfigurationRequest) : Promise<UpdateConfigurationResponse | undefined>
  getSaleStatus(companyId: string): Promise<SaleStatusResponse | undefined>
  checkCompanyForSale(companyId: string, organizationNumber:string) : Promise<CheckCompanyForSaleResponse | undefined>
}

export default class WebShopService implements IWebShopService {
  apiBase: string;
  apiClient: IApiClient;

  constructor(apiClient: IApiClient) {
    this.apiBase = '/api/webshop';
    this.apiClient = apiClient;
  }
  async checkCompanyForSale(companyId: string, organizationNumber: string): Promise<CheckCompanyForSaleResponse | undefined> {
    
    
    try {
      const response = await this.apiClient.get<CheckCompanyForSaleResponse>(
        `${this.apiBase}/CheckCompanyForSale?companyId=${companyId}&organizationNumber=${organizationNumber}`
      );
      return response ? response : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }

  async getSaleStatus(companyId: string): Promise<SaleStatusResponse | undefined> {
    try {
      const response = await this.apiClient.get<SaleStatusResponse>(
        `${this.apiBase}/getSaleStatus/${companyId}`
      );
      return response ? response : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }
  


  async addOrder(order: WebshopOrderModel): Promise<WebShopOrderResponse | undefined> {
    const response = await this.apiClient.post<WebshopOrderModel, WebShopOrderResponse>(`${this.apiBase}/addorder`, order);
    return response;
}


  async addProduct(formData: FormData): Promise<AddProductResponse | undefined> {
    try {
      const response = await this.apiClient.post<FormData, AddProductResponse>(
        `${this.apiBase}/addproduct`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      );
      return response ? response : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }

  async hasPendingOrder(companyId: string, organizationNumber: string): Promise<PendingOrderResponse | undefined> {
    try {
      const response = await this.apiClient.get<PendingOrderResponse>(
        `${this.apiBase}/hasPendingOrder/${companyId}/${organizationNumber}`
      );
      return response ? response : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }

  async getProducts() {
    try {
      const response = await this.apiClient.get<GetProductsResponse>(
        `${this.apiBase}/getProducts/`
      );
      return response ? response.productDefinitions : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }
  
  async applyCoupon(code: string): Promise<ApplyCouponResponse | undefined> {
    try {
      const response = await this.apiClient.get<ApplyCouponResponse>(
        `${this.apiBase}/ApplyCouponCode/${code}`
      );
      return response ? response: undefined;
    } catch (exception) {
      console.error(exception);
    }
  }
  

  async getProductConfigurations(companyId: string): Promise<GetProductConfigurationsResponse | undefined> {
    try {
      const response = await this.apiClient.get<GetProductConfigurationsResponse>(
        `${this.apiBase}/getProductConfigurations/${companyId}`
      );
      return response ? response : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }
  
  async updateProductConfiguration(request: UpdateConfigurationRequest): Promise<UpdateConfigurationResponse | undefined> {
    try {
      const response = await this.apiClient.post<UpdateConfigurationRequest, UpdateConfigurationResponse>(
        `${this.apiBase}/UpdateProductConfiguration/`, request
      );
      return response ? response : undefined;
    } catch (exception) {
      console.error(exception);
    }
  }

}